<template>
    <div class="w3-margin">
        <h4 class="page-title">GYIK</h4>  

        <div class="w3-justify">
            <div v-if="showGyik1"> 
                <div class="w3-margin">
                    <div class="w3-text-green uppercase">Okostelefon nélkül tudom igazolni a túrák teljesítését?</div>
                    <div class="w3-padding w3-justify">Nem. A teljesítések igazolása csak a csavarGO alkalmazással lehetséges, az alkalmazás használatához okostelefonra van szükség.</div>
                </div>
                <div class="w3-margin">
                    <div class="w3-text-green uppercase">Kell bármilyen programot telepítenem a telefonomra a teljesítés megkezdése előtt?</div>
                    <div class="w3-padding w3-justify">Nem. A csavarGO böngészőben fut, ilyen alkalmazás minden telefonon megtalálható. Azt azonban érdemes ellenőrizni, hogy a böngésző verziója megfelel-e a Technikai információk fejezetben leírtaknak.</div>
                </div>  
                <div class="w3-margin">
                    <div class="w3-text-green uppercase">A csavarGO most akkor weboldal vagy alkalmazás?</div>
                    <div class="w3-padding w3-justify">A csavarGO egy PWA (Progressive Web Apps) weboldal. Ez egy viszonylag új technológia, ami többek között azt is lehetővé teszi, hogy az oldal offline állapotban is használható legyen. Ha hozzáadod a kezdőképernyőhöz, lesz egy ikonja, amivel közvetlenül indítható. Ha így indítod el az oldalt, úgy néz ki, mintha egy telepített alkalmazás lenne. A kezdőképernyőhöz adás után meg is jelenik a telepített alkalmazások listájában, azaz innentől kezdve a weboldal már tekinthető alkalmazásnak.</div>
                </div>
                <div class="w3-margin">
                    <div class="w3-text-green uppercase">Hogyan tudom leellenőrizni, hogy a helymeghatározás működik-e a telfonomon a választott böngészőben?</div>
                    <div class="w3-padding w3-justify">Kapcsold be a GPS-t, majd töltsd be a csavargo.eu oldalt a választott böngészőben. A menüben kattints a HELYMEGHATÁROZÁS menüpontra. A böngésző kérni fogja a helyadatok megosztásának engedélyezését. Engedélyezd! Ezt követően meg kell jelennie az aktuális pozíciódnak a térképen.
                        <br>Ha valamiért nem sikerült az engedélyezés, akkor a böngésző Beállítások/Webhelybeállítások/Tartózkodási hely menüjében manuálisan tudod beállítani.
                        <br><span class="w3-text-red">Kérjük, hogy ezt az ellenőrzést mindenképp végezd el az első teljesítés előtt!</span>
                        </div>
                </div>       
                <div class="w3-margin">
                    <div class="w3-text-green uppercase">Iphone-om van, de nem tudok igazolni az ellenőrzőponton. Mi lehet a hiba?</div>
                    <div class="w3-padding w3-justify">Ellenőrizd, hogy a készülék-böngésző párosítás megfelel-e a Technikai információk fejezetben leírtaknak! Ha igen, ellenőrizd, hogy a telefonon engedélyezve van-e a böngészőben a helymeghatározás! Erről a beállításról <a class="cursorpointer w3-text-blue" href="https://support.apple.com/hu-hu/HT207092" target="_blank">ezen a linken</a> olvashatsz.</div>
                </div>     
                <div class="w3-margin">
                    <div class="w3-text-green uppercase">Kell internetkapcsolattal (mobilnet) rendelkeznem a teljesítés során?</div>
                    <div class="w3-padding w3-justify">Nem. A teljesítés történhet offline állapotban is, azonban a túra előtt le kell tölteni a csavarGO alkalmazással a túra adatait, illetve teljesítés után a teljesítési adatok feltöltéséhez szintén szükséges internetkapcsolat.</div>
                </div>
                <div class="w3-margin">
                    <div class="w3-text-green uppercase">Teljesítés közben folyamatosan futnia kell a csavarGO alkalmazásnak?</div>
                    <div class="w3-padding w3-justify">Nem. A csavarGO-t elég az ellenőrzőpontok közelében elindítani. Útközben ki lehet kapcsolni az alkalmazást vagy akár a telefont is. Fontos, hogy offline teljesítés esetén az alkalmazásból nem szabad kijelentkezni. (A programból való kilépés nem von maga után kijelentkeztetést.)</div>
                </div>
                <div class="w3-margin">
                    <div class="w3-text-green uppercase">Mi történik, ha elfelejtek valamelyik ellenőrzőponton igazolni?</div>
                    <div class="w3-padding w3-justify">A teljesítés csak akkor lesz sikeres, ha minden ellenőrzőponton igazolsz. Ezért, ha szintidőn belül lehetőséged van rá, akkor menj vissza a pontra és igazold!</div>
                </div>
                <div class="w3-margin">
                    <div class="w3-text-green uppercase">Mi történik, ha programhiba miatt nem tudok valamelyik ponton igazolni?</div>
                    <div class="w3-padding w3-justify">A teljesítést a csavarGO sikertelen teljesítésként fogja értelmezni. Ezért készíts egy olyan fényképet magadról, amelyen jól felismerhető az ellenőrzőpont is. A túra után küldd el e-mailben és mi manuálisan átállítjuk teljesítésed adatait. Kérjük, hogy ezzel a lehetőséggel csak akkor élj, ha tényleg a program hibás működése miatt nem tudtál igazolni. Pl.: ha a telefonod lemerül, az nem tekinthető programhibának.</div>
                </div>
                <div class="w3-margin">
                    <div class="w3-text-green uppercase">Mikor teljesíthető egy adott túra?</div>
                    <div class="w3-padding w3-justify">Bármikor, amikor a túra útvonalán nincs erdőlátogatási korlátozás.</div>
                </div>
                <div class="w3-margin">
                    <div class="w3-text-green uppercase">Teljesíthetek többször is egy adott túrát?</div>
                    <div class="w3-padding w3-justify">Igen. Egy lezárt (sikeres vagy sikertelen) teljesítést követően bármikor újra kezdheted a túra teljesítését.</div>
                </div>
                <div class="w3-margin">
                    <div class="w3-text-green uppercase">Lehet online követni a teljesítésemet?</div>
                    <div class="w3-padding w3-justify">Igen. Amennyiben a teljesítés során rendelkezel internetkapcsolattal, akkor menet közben feltöltődnek a teljesítési adatok. A teljesítés a csavargo.eu oldalon nyomon követhető. Természetesen, ha offline módban teljesíted a túrát, akkor erre nincs lehetőség.</div>
                </div>
                <div class="w3-margin">
                    <div class="w3-text-green uppercase">A csavarGO-t tudom használni navigációs programként is?</div>
                    <div class="w3-padding w3-justify">Igen. Egy pont igazolásának kiválasztásakor a program térkép nézetre vált, ahol láthatod az aktuális pozíciódat, az ellenőrzőpontot és a túra nyomvonalát. Ha van internetkapcsolatod, akkor a beállított térképforrásnak megfelelő térkép is megjelenik. Jelenleg az alkalmazás offline térképeket nem tud használni, de az eltévedés mentes útvonalkövetéshez a nyomvonal és az aktuális pozíciók megjelenítése is elegendő lehet.</div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Gyik',    
    data() {
        return {
            showGyik1:true,
            showGyik2:false,    
        }
    },
    methods:{
        shwGyik1(){
            this.showGyik1=true;  
            this.showGyik2=false;
        },
        shwGyik2(){
            this.showGyik2=true;  
            this.showGyik1=false;
        },
        toggleGyik1(){
            this.showGyik1=!this.showGyik1;
        },
        toggleGyik2(){
            this.showGyik2=!this.showGyik2;
        },
    },
}
</script>

